import React, { Component } from 'react'
import { MarketsFilters } from './MarketsFilters'
import { ExchangeSearch } from './ExchangeSearch'
import bem from './bem'
import { intl } from 'src/i18n'

const cName = bem.with('MarketsHeader')

export class MarketsExchangeHeader extends Component {
  onInput = key => this.props.onSearch(key)

  render() {
    const { filters, coinName, isMobile, inputRef } = this.props

    return (
      <>
        <div className={cName()}>
          {!isMobile ? (
            <>
              <h2 className={cName('Title')}>
                {intl.t(
                  'coinDetails.marketsTab.marketsExchangeHeader.markets',
                  { coinName }
                )}
              </h2>
              <div className={cName('FiltersWrapper')}>
                <ExchangeSearch
                  onInput={key => this.onInput(key)}
                  inputRef={inputRef}
                />
                <MarketsFilters filters={filters} />
              </div>
            </>
          ) : (
            <>
              <div className={cName('FiltersWrapper')}>
                <h2 className={cName('Title')}>
                  {intl.t(
                    'coinDetails.marketsTab.marketsExchangeHeader.markets',
                    { coinName }
                  )}
                </h2>
                <MarketsFilters filters={filters} />
              </div>
              <ExchangeSearch
                onInput={key => this.onInput(key)}
                inputRef={inputRef}
              />
            </>
          )}
        </div>
      </>
    )
  }
}
